// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — option-receipt.styled.classic.js, новая — option-receipt.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './option-receipt.styled.classic';
import * as cp from './option-receipt.styled.cp';

export const Block = isCp ? cp.Block : classic.Block;
export const Content = isCp ? cp.Content : classic.Content;
export const Select = isCp ? undefined : classic.Select;
export const Title = isCp ? cp.Title : classic.Title;
